/* ==========================================================================
   NEU INK B2B PDP — 行为层（对话 B）
   --------------------------------------------------------------------------
   1. 尺码数量矩阵 → 合计
   2. 合计 → 套阶梯档 → 算单价 / 总额
   3. 档位提示（“再加 N 双，总额反而少 $X”）
   4. 合计 > 500 → 切 Request a Quote；合计 < 25 → 禁用加购
   5. 包装：免费三选一 + 付费礼盒（盒数向上取整）
   6. 尺码表抽屉
   7. 加购：一次设计 → 按尺码拆成多行

   【Teeinblue 集成契约 —— 实测结论，改代码前先读】
   campaign 分两种，行为完全不同：
     · by Product Base   — Teeinblue 自己渲染 ADD TO CART，页面上没有 properties[*] 字段
     · by Shopify Products — 【我们用的】它**不渲染任何按钮**，show_action_buttons
                              这个开关对它无效。它只提供：
                                - 隐藏字段 properties[_customization_id] 等
                                - JS 接口 setVariantId() / addToCart()
                              而 addToCart() **不自己发请求**，它去 DOM 里找主题的
                              加购按钮并劫持它：先落库生成设计 → 填字段 → 触发 submit。
                              找不到按钮就报 “Add to cart button not found”。
   所以 section 里必须有一个离屏的标准商品表单（.nb-hookform）给它当钩子。
   我们拦截这个表单的 submit，拿到已经填好的 Teeinblue 属性后，再自己按尺码拆行加购。
   离屏不能用 display:none，否则 Teeinblue 可能认为按钮不存在。
   ========================================================================== */
(function () {
  'use strict';

  var money = function (cents) {
    return '$' + (cents / 100).toLocaleString('en-US', {
      minimumFractionDigits: 2, maximumFractionDigits: 2
    });
  };
  var el = function (root, sel) { return root.querySelector(sel); };
  var els = function (root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };

  /* 把页面上所有 properties[*] 抄一份，不硬编码字段名，
     Teeinblue 以后加字段也不用改这里 */
  function collectCustomizationProps() {
    var props = {};
    els(document, '[name^="properties["]').forEach(function (input) {
      var m = input.name.match(/^properties\[(.+)\]$/);
      if (!m) return;
      if ((input.type === 'checkbox' || input.type === 'radio') && !input.checked) return;
      if (input.type === 'file') return;
      var val = input.value;
      if (val === '' || val == null) return;
      props[m[1]] = val;
    });
    return props;
  }

  function init(root) {
    var raw = el(root, '[data-nb-data]');
    if (!raw) return;
    var D;
    try { D = JSON.parse(raw.textContent); }
    catch (e) { console.error('[nb-pdp] data parse failed', e); return; }

    var TIERS = D.tiers;
    var MOQ = D.moq;
    var QUOTE_OVER = D.quoteOver;
    var BASE = D.basePrice;

    var S = {
      color: (D.colors && D.colors.length) ? D.colors[0] : null,
      qty: {},
      packaging: (D.packaging.free[0] || null),
      boxPairs: null
    };
    D.sizes.forEach(function (s) { S.qty[s] = 0; });

    var $ = {
      colors:    el(root, '[data-nb="colors"]'),
      colorReset: el(root, '[data-nb="color-reset"]'),
      sizeRows:  el(root, '[data-nb="size-rows"]'),
      qtyTotal:  el(root, '[data-nb="qty-total"]'),
      tierRows:  el(root, '[data-nb="tier-rows"]'),
      tabTierRows: el(root, '[data-nb="tab-tier-rows"]'),
      volumeOpen: el(root, '[data-nb="volume-open"]'),
      volumeModal: el(root, '[data-nb="volume-modal"]'),
      volumeDialog: el(root, '[data-nb="volume-dialog"]'),
      volumeClose: els(root, '[data-nb="volume-close"]'),
      nudge:     el(root, '[data-nb="nudge"]'),
      moqAlert:  el(root, '[data-nb="moq-alert"]'),
      bigAlert:  el(root, '[data-nb="big-alert"]'),
      pkg:       el(root, '[data-nb="pkg"]'),
      giftbox:   el(root, '[data-nb="giftbox"]'),
      boxSizes:  el(root, '[data-nb="box-sizes"]'),
      boxMath:   el(root, '[data-nb="box-math"]'),
      boxToggle: el(root, '[data-nb="box-toggle"]'),
      sum:       el(root, '[data-nb="sum"]'),
      cta:       el(root, '[data-nb="cta"]'),
      err:       el(root, '[data-nb="err"]'),
      unavail:   el(root, '[data-nb="unavailable"]'),
      variantSkus: el(root, '[data-nb="variant-skus"]')
    };

    var hookForm = el(root, '.nb-hookform');
    var hookTimer = null;
    var hookPollTimer = null;
    var hookAttempt = 0;
    var hookCompleted = false;
    var cartRequestPending = false;
    var hookObserver = null;
    var hookNormalizeTimer = null;

    /*
       Sami 会把标准 ATC 按钮复制成 clone，并把原按钮隐藏。Teeinblue 随后
       可能命中被 Sami 接管的 clone / hidden original，导致设计字段没有落回
       .nb-hookform。这里只整理离屏钩子表单，不改页面上的真实购买按钮。
    */
    function normalizeHookButton() {
      if (!hookForm) return null;
      var buttons = els(hookForm, 'button[name="add"], input[type="submit"]');
      var button = hookForm.querySelector('.samitaWS-original-atc-button') || buttons[0] || null;
      buttons.forEach(function (candidate) {
        if (candidate !== button && candidate.classList.contains('samitaWS-clone-atc-button')) {
          candidate.remove();
        }
      });
      if (!button) return null;
      button.classList.remove('samitaWS-original-atc-button', 'samitaWS-clone-atc-button');
      button.classList.add('nb-tee-hook-button');
      button.hidden = false;
      button.disabled = false;
      button.tabIndex = -1;
      button.style.setProperty('display', 'inline-flex', 'important');
      button.style.setProperty('visibility', 'visible', 'important');
      button.style.setProperty('opacity', '1', 'important');
      return button;
    }

    function observeHookButton() {
      if (!hookForm || !hookObserver) return;
      hookObserver.observe(hookForm, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style', 'hidden', 'disabled']
      });
    }

    function scheduleHookNormalization() {
      if (hookNormalizeTimer) return;
      hookNormalizeTimer = setTimeout(function () {
        hookNormalizeTimer = null;
        if (hookObserver) hookObserver.disconnect();
        normalizeHookButton();
        observeHookButton();
      }, 0);
    }

    function hasTeeinblueProps(props) {
      if (!props) return false;
      if (props._customization_id || props._customization_image) return true;
      return Object.keys(props).some(function (key) {
        return /^_tib_design_link_/i.test(key);
      });
    }

    function clearHookWaiters() {
      if (hookTimer) { clearTimeout(hookTimer); hookTimer = null; }
      if (hookPollTimer) { clearTimeout(hookPollTimer); hookPollTimer = null; }
    }

    function completeTeeinblueHook(source) {
      if (hookCompleted || cartRequestPending) return false;
      if (!hasTeeinblueProps(collectCustomizationProps())) return false;
      hookCompleted = true;
      clearHookWaiters();
      console.log('[nb-pdp] teeinblue design ready via ' + source + ' → taking over add-to-cart');
      doAjaxAdd();
      return true;
    }

    function pollForTeeinblueProps(attempt) {
      if (attempt !== hookAttempt || hookCompleted || cartRequestPending) return;
      if (completeTeeinblueHook('property sync')) return;
      hookPollTimer = setTimeout(function () { pollForTeeinblueProps(attempt); }, 200);
    }

    if (hookForm) {
      normalizeHookButton();
      if (window.MutationObserver) {
        hookObserver = new MutationObserver(function () {
          var dirty = hookForm.querySelector('.samitaWS-clone-atc-button, .samitaWS-original-atc-button') ||
            els(hookForm, 'button[name="add"], input[type="submit"]').length > 1;
          if (dirty) scheduleHookNormalization();
        });
        observeHookButton();
      }
      window.setTimeout(normalizeHookButton, 250);
      window.setTimeout(normalizeHookButton, 1200);
    }

    function showError(message) {
      if (!$.err) return;
      $.err.textContent = message || '';
      $.err.hidden = !message;
    }

    function total() {
      return D.sizes.reduce(function (a, s) { return a + (S.qty[s] || 0); }, 0);
    }
    function tierIndex(q) {
      var i = 0;
      for (var k = 0; k < TIERS.length; k++) { if (q >= TIERS[k].min) i = k; }
      return i;
    }
    function unitAt(i) { return Math.round(BASE * (1 - TIERS[i].pct / 100)); }
    function variantFor(size) {
      for (var i = 0; i < D.variants.length; i++) {
        var v = D.variants[i];
        if (v.size !== size) continue;
        if (S.color && v.color && v.color !== S.color) continue;
        if (!v.available) continue;
        return v;
      }
      return null;
    }
    function variantForDisplay(size) {
      for (var i = 0; i < D.variants.length; i++) {
        var v = D.variants[i];
        if (v.size !== size) continue;
        if (S.color && v.color !== S.color) continue;
        return v;
      }
      return null;
    }
    function renderVariantSkus() {
      if (!$.variantSkus) return;
      var items = [];
      D.sizes.forEach(function (size) {
        var v = variantForDisplay(size);
        if (v) items.push(size + ': ' + (v.sku || 'Not provided'));
      });
      $.variantSkus.textContent = items.length ? items.join(' · ') : 'Not provided';
    }
    function firstSelectedVariant() {
      for (var i = 0; i < D.sizes.length; i++) {
        var s = D.sizes[i];
        if ((S.qty[s] || 0) > 0) { var v = variantFor(s); if (v) return v; }
      }
      return null;
    }

    function renderColors() {
      if (!$.colors || !D.colors.length) return;
      $.colors.innerHTML = '';
      D.colors.forEach(function (c) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'nb-color';
        b.textContent = c;
        b.setAttribute('aria-pressed', String(S.color === c));
        b.addEventListener('click', function () {
          if (S.color === c) return;
          var cleared = total();
          S.color = c;
          D.sizes.forEach(function (s) { S.qty[s] = 0; });
          els(root, '.nb-qty').forEach(function (inp) { inp.value = '0'; });
          if ($.colorReset) {
            $.colorReset.textContent = cleared
              ? 'Quantities were cleared because each configuration can use one color.'
              : '';
            $.colorReset.hidden = !cleared;
          }
          renderColors();
          update();
        });
        $.colors.appendChild(b);
      });
    }

    function buildSizeRows() {
      $.sizeRows.innerHTML = '';
      D.sizes.forEach(function (s) {
        var tr = document.createElement('tr');
        var td1 = document.createElement('td');
        td1.innerHTML = '<span class="nb-sizecell"><b></b><small></small></span>';
        td1.querySelector('b').textContent = s;
        td1.querySelector('small').setAttribute('data-nb-sku', s);
        var td2 = document.createElement('td');
        td2.className = 'nb-r';
        var inp = document.createElement('input');
        inp.type = 'number'; inp.min = '0'; inp.step = '1'; inp.value = '0';
        inp.className = 'nb-qty';
        inp.setAttribute('data-nb-size', s);
        inp.setAttribute('inputmode', 'numeric');
        inp.setAttribute('aria-label', 'Pairs, size ' + s);
        inp.addEventListener('input', function () {
          var n = parseInt(inp.value || '0', 10);
          S.qty[s] = (isNaN(n) || n < 0) ? 0 : n;
          update();
        });
        td2.appendChild(inp);
        tr.appendChild(td1); tr.appendChild(td2);
        $.sizeRows.appendChild(tr);
      });
    }

    function buildPackaging() {
      if (!$.pkg) return;
      $.pkg.innerHTML = '';
      D.packaging.free.forEach(function (name) {
        var lab = document.createElement('label');
        lab.className = 'nb-opt' + (S.packaging === name ? ' is-on' : '');
        var inp = document.createElement('input');
        inp.type = 'radio'; inp.name = 'nb-pkg-' + D.productId; inp.value = name;
        inp.checked = (S.packaging === name);
        inp.addEventListener('change', function () { S.packaging = name; buildPackaging(); update(); });
        var wrap = document.createElement('span');
        var t = document.createElement('span'); t.className = 'nb-opt__t'; t.textContent = name;
        var d = document.createElement('span'); d.className = 'nb-opt__d'; d.textContent = 'Included — no extra charge';
        wrap.appendChild(t); wrap.appendChild(d);
        lab.appendChild(inp); lab.appendChild(wrap);
        $.pkg.appendChild(lab);
      });

      if (!$.boxSizes || !D.packaging.giftBox) return;
      $.boxSizes.innerHTML = '';
      D.packaging.giftBox.variants.forEach(function (v) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'nb-boxpick';
        b.textContent = v.title + (v.price ? ' · ' + money(v.price) + '/box' : '');
        b.setAttribute('aria-pressed', String(S.boxPairs === v.pairs));
        b.addEventListener('click', function () {
          S.boxPairs = (S.boxPairs === v.pairs) ? null : v.pairs;
          buildPackaging(); update();
        });
        $.boxSizes.appendChild(b);
      });
    }

    function update() {
      var q = total();
      var idx = tierIndex(q);
      var unit = unitAt(idx);
      var under = q > 0 && q < MOQ;
      var over = q > QUOTE_OVER;

      $.qtyTotal.textContent = q.toLocaleString('en-US');
      renderVariantSkus();

      var missing = [];
      D.sizes.forEach(function (s) {
        var v = variantFor(s);
        var tag = el(root, '[data-nb-sku="' + s + '"]');
        var input = el(root, '[data-nb-size="' + s + '"]');
        if (tag) tag.textContent = v ? (v.sku || '') : 'not available in this color';
        if (input) input.disabled = !v;
        if (!v && S.qty[s] > 0) missing.push(s);
      });
      if ($.unavail) {
        $.unavail.hidden = !missing.length;
        if (missing.length) {
          $.unavail.textContent = 'These sizes are not available in ' + S.color + ': ' + missing.join(', ');
        }
      }

      function renderTierRows(container) {
        if (!container) return;
        var isModal = container === $.tierRows;
        container.innerHTML = '';
        TIERS.forEach(function (t, i) {
          var tr = document.createElement('tr');
          if (!isModal && q >= MOQ && i === idx) tr.className = 'is-on';
          if (isModal) {
            tr.innerHTML =
              '<td><div class="nb-volume-table__quantity">' +
                '<span class="nb-volume-table__best" hidden>Best value</span>' +
                '<span class="nb-volume-table__range"></span>' +
              '</div></td><td class="nb-r"></td>';
            tr.querySelector('.nb-volume-table__range').textContent = t.label;
            if (i === TIERS.length - 1) {
              tr.querySelector('.nb-volume-table__best').hidden = false;
            }
          } else {
            tr.innerHTML = '<td></td><td class="nb-r"></td>';
            tr.children[0].textContent = t.label + ' pairs';
          }
          tr.children[1].textContent = money(unitAt(i));
          container.appendChild(tr);
        });
      }
      renderTierRows($.tierRows);
      renderTierRows($.tabTierRows);

      var next = TIERS[idx + 1];
      if (q >= MOQ && next && q < QUOTE_OVER) {
        var need = next.min - q;
        var save = unit * q - unitAt(idx + 1) * next.min;
        $.nudge.hidden = false;
        $.nudge.innerHTML =
          'Add <b>' + need.toLocaleString('en-US') + '</b> more pair' + (need === 1 ? '' : 's') +
          ' to reach <b>' + money(unitAt(idx + 1)) + '</b>/pair' +
          (save > 0 ? ' — your order total drops by <b>' + money(save) + '</b>.' : '.');
      } else {
        $.nudge.hidden = true;
        $.nudge.innerHTML = '';
      }

      $.moqAlert.hidden = !under;
      if (under) {
        $.moqAlert.innerHTML =
          '<b>Minimum order is ' + MOQ + ' pairs.</b> Add ' + (MOQ - q) +
          ' more to continue. Mixed sizes are fine — the ' + MOQ + '-pair minimum is the combined total.';
      }
      $.bigAlert.hidden = !over;

      var boxTotal = 0;
      if ($.giftbox) {
        var wantBox = $.boxToggle ? $.boxToggle.checked : false;
        $.giftbox.hidden = !wantBox;
        if (!wantBox) S.boxPairs = null;
        if ($.boxMath) {
          if (wantBox && S.boxPairs && q > 0) {
            var boxes = Math.ceil(q / S.boxPairs);
            var slack = boxes * S.boxPairs - q;
            var bv = D.packaging.giftBox.variants.filter(function (v) { return v.pairs === S.boxPairs; })[0];
            boxTotal = bv ? bv.price * boxes : 0;
            $.boxMath.innerHTML =
              '<b>' + q.toLocaleString('en-US') + '</b> pairs ÷ ' + S.boxPairs + '-pair box = <b>' +
              boxes.toLocaleString('en-US') + ' boxes</b> (rounded up)' +
              (bv && bv.price ? ' · ' + money(boxTotal) : ' · price TBC') +
              (slack > 0
                ? '<br><span style="color:#7a5600">Add <b>' + slack + '</b> more pair' + (slack === 1 ? '' : 's') +
                  ' to fill the last box exactly.</span>'
                : '<br><span style="color:#1f6b36">Fills every box exactly.</span>');
          } else {
            $.boxMath.innerHTML = wantBox ? 'Pick a box size above.' : '';
          }
        }
      }

      var goods = unit * q;
      var rows = '';
      rows += '<div class="nb-sum__row"><span>' + D.title + (S.color ? ' · ' + S.color : '') +
              '</span><span>' + money(unit) + ' /pair</span></div>';
      if (D.imprintNote) {
        rows += '<div class="nb-sum__row nb-sum__row--sub"><span>' + D.imprintNote +
                '</span><span>included</span></div>';
      }
      rows += '<div class="nb-sum__row nb-sum__row--subtotal">' +
              '<span><b>' + money(unit) + '</b> × ' + q.toLocaleString('en-US') + ' pairs</span>' +
              '<span>' + money(goods) + '</span></div>';
      if (S.packaging) {
        rows += '<div class="nb-sum__row nb-sum__row--sub"><span>Packaging · ' + S.packaging +
                '</span><span>included</span></div>';
      }
      if (S.boxPairs && q > 0) {
        var nbx = Math.ceil(q / S.boxPairs);
        var bvv = D.packaging.giftBox.variants.filter(function (v) { return v.pairs === S.boxPairs; })[0];
        rows += '<div class="nb-sum__row"><span>Gift box · ' + S.boxPairs + '-pair × ' + nbx +
                '</span><span>' + (bvv && bvv.price ? money(boxTotal) : 'TBC') + '</span></div>';
      }
      rows += '<div class="nb-sum__row nb-sum__row--total"><span>Total</span><span>' +
              money(goods + boxTotal) + '</span></div>';
      $.sum.innerHTML = rows;

      $.cta.classList.toggle('is-quote', over);
      $.cta.textContent = over ? 'Request a Quote'
        : (!D.teeinblueBound ? 'Customization unavailable'
        : (q >= MOQ ? 'Add to Cart — ' + money(goods + boxTotal) : 'Add to Cart'));
      $.cta.disabled = !over && (!D.teeinblueBound || q < MOQ || missing.length > 0);
      showError('');
    }

    function buildItems() {
      var shared = collectCustomizationProps();
      var designId = shared._customization_id || null;
      var items = [];
      var groupToken = 'nb-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);

      D.sizes.forEach(function (s) {
        var n = S.qty[s] || 0;
        if (n <= 0) return;
        var v = variantFor(s);
        if (!v) return;
        var props = {};
        Object.keys(shared).forEach(function (k) { props[k] = shared[k]; });
        if (S.packaging) props['Packaging'] = S.packaging;
        props['_neuink_group'] = groupToken;
        props['_neuink_size'] = s;
        items.push({ id: v.id, quantity: n, properties: props });
      });

      if (S.boxPairs && D.packaging.giftBox) {
        var q = total();
        var bv = D.packaging.giftBox.variants.filter(function (v) { return v.pairs === S.boxPairs; })[0];
        if (bv && q > 0) {
          items.push({
            id: bv.id,
            quantity: Math.ceil(q / S.boxPairs),
            properties: {
              '_neuink_group': groupToken,
              '_neuink_for': D.title,
              'Box size': bv.title,
              'For design': designId || '—'
            }
          });
        }
      }
      return items;
    }

    /* 真正发请求的那一步（尺码拆行） */
    function doAjaxAdd() {
      var customization = collectCustomizationProps();
      if (cartRequestPending) return;
      if (D.teeinblueBound && !hasTeeinblueProps(customization)) {
        hookCompleted = false;
        $.cta.classList.remove('is-busy');
        showError('Your design was not attached. Upload the artwork and complete PREVIEW before adding to cart.');
        return;
      }
      var items = buildItems();
      if (!items.length) {
        $.cta.classList.remove('is-busy');
        showError('Enter quantities first.');
        return;
      }
      cartRequestPending = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          $.cta.classList.remove('is-busy');
          if (!res.ok) {
            cartRequestPending = false;
            hookCompleted = false;
            showError((res.body && (res.body.description || res.body.message)) || 'Could not add to cart.');
            console.error('[nb-pdp] cart/add failed', res.body);
            return;
          }
          console.log('[nb-pdp] added', res.body);
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('samita:cart:refresh', { bubbles: true }));
          window.location.href = '/cart';
        })
        .catch(function (e) {
          cartRequestPending = false;
          hookCompleted = false;
          $.cta.classList.remove('is-busy');
          showError('Network error — please try again.');
          console.error('[nb-pdp]', e);
        });
    }

    /* 拦截钩子表单的 submit——Teeinblue 到这一步已经把设计落库并填好字段了 */
    if (hookForm) {
      hookForm.addEventListener('submit', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        completeTeeinblueHook('form submit');
      }, true);
    }

    function addToCart() {
      if (!D.teeinblueBound) {
        showError('Online customization is not connected for this product yet.');
        return;
      }
      var v0 = firstSelectedVariant();
      if (!v0) { showError('Enter quantities first.'); return; }
      if (cartRequestPending) return;
      clearHookWaiters();
      hookCompleted = false;
      hookAttempt += 1;
      $.cta.classList.add('is-busy');
      showError('');

      var tib = window.teeinblue;
      if (tib && typeof tib.addToCart === 'function' && hookForm) {
        normalizeHookButton();
        var idInput = hookForm.querySelector('[name="id"]');
        var qtyInput = hookForm.querySelector('[name="quantity"]');
        if (idInput) idInput.value = v0.id;
        if (qtyInput) qtyInput.value = 1;

        // 钩子没打上时必须诚实失败，绝不绕过 Teeinblue 裸加购。
        var thisAttempt = hookAttempt;
        hookTimer = setTimeout(function () {
          if (thisAttempt !== hookAttempt || hookCompleted || cartRequestPending) return;
          hookTimer = null;
          if (hookPollTimer) { clearTimeout(hookPollTimer); hookPollTimer = null; }
          $.cta.classList.remove('is-busy');
          showError('The customization service did not finish. Please retry PREVIEW or contact our B2B team.');
          console.warn('[nb-pdp] teeinblue hook did not finish in 20s; cart was not changed');
        }, 20000);
        pollForTeeinblueProps(thisAttempt);

        Promise.resolve(tib.setVariantId ? tib.setVariantId(v0.id) : null)
          .then(function () {
            normalizeHookButton();
            return tib.addToCart();
          })
          .catch(function (err) {
            console.warn('[nb-pdp] teeinblue.addToCart failed; cart was not changed', err);
            hookCompleted = true;
            clearHookWaiters();
            $.cta.classList.remove('is-busy');
            showError('The customization service could not attach your design. Please retry PREVIEW.');
          });
        return;
      }
      $.cta.classList.remove('is-busy');
      showError('The customization service is still loading. Please wait a moment and retry.');
    }

    function goToQuote() {
      var payload = {
        product: D.title, handle: D.handle, sku: D.sku,
        color: S.color, qty: S.qty, total: total(),
        packaging: S.packaging, giftBoxPairs: S.boxPairs,
        customization: collectCustomizationProps()
      };
      try { sessionStorage.setItem('neuink_quote_request', JSON.stringify(payload)); } catch (e) {}
      var form = document.querySelector(D.quoteTarget || '#NeuinkB2BFooterQuote');
      if (!form) {
        showError('The quote form is unavailable on this preview. Please use the B2B contact link in the header.');
        return;
      }
      var setContext = function (name, value) {
        var input = form.querySelector('[name="' + name + '"]');
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = name;
          form.appendChild(input);
        }
        input.value = value;
      };
      setContext('contact[Product]', D.title);
      setContext('contact[Pairs]', String(total()));
      setContext('contact[Color]', S.color || '');
      form.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var email = form.querySelector('input[type="email"]');
      if (email) window.setTimeout(function () { email.focus({ preventScroll: true }); }, 450);
    }

    $.cta.addEventListener('click', function () {
      if (total() > QUOTE_OVER) { goToQuote(); } else { addToCart(); }
    });
    if ($.boxToggle) $.boxToggle.addEventListener('change', update);

    var volumeReturnFocus = null;
    function openVolumeModal() {
      if (!$.volumeModal || !$.volumeDialog) return;
      volumeReturnFocus = document.activeElement;
      $.volumeModal.hidden = false;
      if ($.volumeOpen) $.volumeOpen.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('nb-volume-is-open');
      try { $.volumeDialog.focus({ preventScroll: true }); }
      catch (e) { $.volumeDialog.focus(); }
    }
    function closeVolumeModal() {
      if (!$.volumeModal || $.volumeModal.hidden) return;
      $.volumeModal.hidden = true;
      if ($.volumeOpen) $.volumeOpen.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('nb-volume-is-open');
      if (volumeReturnFocus && typeof volumeReturnFocus.focus === 'function') {
        volumeReturnFocus.focus({ preventScroll: true });
      }
      volumeReturnFocus = null;
    }
    if ($.volumeOpen) $.volumeOpen.addEventListener('click', openVolumeModal);
    $.volumeClose.forEach(function (button) {
      button.addEventListener('click', closeVolumeModal);
    });
    if ($.volumeModal && $.volumeDialog) {
      $.volumeModal.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          e.preventDefault();
          closeVolumeModal();
          return;
        }
        if (e.key !== 'Tab') return;
        var focusable = els($.volumeDialog,
          'button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        ).filter(function (node) { return !node.hidden && node.offsetParent !== null; });
        if (!focusable.length) {
          e.preventDefault();
          $.volumeDialog.focus();
          return;
        }
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      });
    }

    var tabs = els(root, '[data-nb-tab]');
    var panels = els(root, '[data-nb-panel]');
    function activateTab(tab, moveFocus) {
      var name = tab.getAttribute('data-nb-tab');
      tabs.forEach(function (item) {
        var on = item === tab;
        item.setAttribute('aria-selected', String(on));
        item.tabIndex = on ? 0 : -1;
      });
      panels.forEach(function (panel) {
        panel.hidden = panel.getAttribute('data-nb-panel') !== name;
      });
      if (moveFocus) tab.focus();
    }
    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () { activateTab(tab, false); });
      tab.addEventListener('keydown', function (e) {
        var next = null;
        if (e.key === 'ArrowRight') next = tabs[(index + 1) % tabs.length];
        if (e.key === 'ArrowLeft') next = tabs[(index - 1 + tabs.length) % tabs.length];
        if (e.key === 'Home') next = tabs[0];
        if (e.key === 'End') next = tabs[tabs.length - 1];
        if (next) { e.preventDefault(); activateTab(next, true); }
      });
    });

    renderColors();
    buildSizeRows();
    buildPackaging();
    update();

    root.nbDebug = {
      data: D, state: S, items: buildItems, hookForm: hookForm,
      props: collectCustomizationProps,
      addToCart: addToCart, doAjaxAdd: doAjaxAdd
    };
    window.nbDebug = root.nbDebug;
  }

  function boot() { els(document, '.nb-pdp').forEach(init); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();
